"use strict";

exports.__esModule = true;
var _SurfaceElement = require("./SurfaceElement");
Object.keys(_SurfaceElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SurfaceElement[key]) return;
  exports[key] = _SurfaceElement[key];
});
var _SurfaceFields = require("./SurfaceFields");
Object.keys(_SurfaceFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SurfaceFields[key]) return;
  exports[key] = _SurfaceFields[key];
});
var _EditableSurfaceElement = require("./EditableSurfaceElement");
Object.keys(_EditableSurfaceElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableSurfaceElement[key]) return;
  exports[key] = _EditableSurfaceElement[key];
});
var _SurfaceThumbnail = require("./SurfaceThumbnail");
Object.keys(_SurfaceThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SurfaceThumbnail[key]) return;
  exports[key] = _SurfaceThumbnail[key];
});
var _SurfaceHeader = require("./SurfaceHeader");
Object.keys(_SurfaceHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SurfaceHeader[key]) return;
  exports[key] = _SurfaceHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});